
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/news/[...slug]",
      function () {
        return require("private-next-pages/[lang]/news/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/news/[...slug]"])
      });
    }
  